import { EnvironmentModel } from '../app/model/environment/environment.model';

export const environment: EnvironmentModel = {
  identity: 'production',

  production: true,

  serverUrl: 'https://cod-server-orchestra-live.herokuapp.com',

  clientUrl: 'https://codigrate.com',

  oauth: {
    twitter: {
      tag: 'TWITTER'
    },
    google: {
      tag: 'GOOGLE'
    },
    facebook: {
      tag: 'FACEBOOK'
    },
    linkedin: {
      tag: 'LINKEDIN'
    },
    twitch: {
      tag: 'TWITCH'
    },
    github: {
      tag: 'GITHUB'
    },
    dribbble: {
      tag: 'DRIBBBLE'
    },
    reddit: {
      tag: 'REDDIT'
    }
  },

  payment: {
    stripe: {
      tag: 'STRIPE',
      publishableKey: '',
    },
    paypal: {
      tag: 'PAYPAL',
      clientId: '',
      env: 'live'
    }
  },

  fileStorage: {
    aws: {
      tag: 'AWS'
    },
    googleCloud: {
      tag: 'GOOGLE_CLOUD'
    }
  },

  mail: {
    gmail: {
      tag: 'GMAIL'
    },
    yahoo: {
      tag: 'YAHOO'
    },
    outlook: {
      tag: 'OUTLOOK'
    }
  },

  sms: {
    twillio: {
      tag: 'TWILLIO'
    },
    awsSns: {
      tag: 'AWS_SNS'
    }
  },

  analytics: {
    googleAnalytics: {
      tag: 'GTM-KRXR22B',
      id: '',
      endpoint: '',
    },
    matomo: {
      tag: '',
      id: '',
      endpoint: '',
    },
    mixPanel: {
      tag: '55a96e2c31b0a86fbee8f5ad61cba24a',
      id: '',
      endpoint: 'https://api-eu.mixpanel.com',
    }
  }
};
